import { render, staticRenderFns } from "./FileCover.vue?vue&type=template&id=a503c80a&scoped=true&"
import script from "./FileCover.vue?vue&type=script&lang=js&"
export * from "./FileCover.vue?vue&type=script&lang=js&"
import style0 from "./FileCover.vue?vue&type=style&index=0&id=a503c80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a503c80a",
  null
  
)

export default component.exports